import CloseIcon from '@mui/icons-material/Close';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  Typography
} from '@mui/material';
import { useEffect, useState } from 'react';
import { PopupComponent } from 'src/components/common/PopupComponent';
import { openCRFModel } from 'src/store/CrfFormsAction';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import CRFFormModal from './CRFFormModal';
import CRFVisitEventsMenu from './CRFVisitEventsMenu';
import { hideLoader, showLoader } from 'src/store/Loader';
import { ContentLoader } from '@pihealth/common-ui-library';

const CRFBasePopup = ({
  selectedCRFFormCode,
  crfFormMetaData,
  parent_id,
  isUpdate,
  setisUpdate,
  selectedVisit,
  visitsData,
  editRowData,
  setselectedVisit,
  seteditRowData,
  bookMarkKey,
  bookMarkField,
  isAddCliked,
  setisAddCliked,
  isAddMode,
  individualEventData,
  setcrfFormMetaData,
  loading,
  selectedAppointment
}: any) => {
  const dispatch = useAppDispatch();
  const isOpenCRFModel = useAppSelector(state => state.CRFForms.isOpenCRFModel);
  const [open, setOpen] = useState(false);
  const [exitValue, setExitValue] = useState(false);
  const [exitPopup, setExitPopup] = useState(false);

  const [currentAddedEvent, setcurrentAddedEvent] = useState<any>(null);
  const [currentEditEventData, setcurrentEditEventData] = useState<any>(null);
  const handleClose = () => {
    if (exitValue) {
      setExitPopup(true);
    } else {
      dispatch(openCRFModel(false));
      setisUpdate(false);
      setisUpdate(false);
      setisAddCliked(false);
      setselectedVisit(null);
      seteditRowData(null);
      setcrfFormMetaData(null);
    }
  };
  useEffect(() => {
    setOpen(isOpenCRFModel);
  }, [isOpenCRFModel]);

  const [modifiedFormConfig, setmodifiedFormConfig] = useState<any>();

  const didsetmodifiedFormConfig = (result: any) => {
    setmodifiedFormConfig(result);
  };

  useEffect(() => {
    didsetmodifiedFormConfig(crfFormMetaData);
  }, [crfFormMetaData]);
  const handleExitPopupClose = () => {
    setExitPopup(false);
  };
  const handleExitPopupSubmit = () => {
    setExitPopup(false);
    setExitValue(false);
    dispatch(openCRFModel(false));
    setisUpdate(false);
    setisUpdate(false);
    setisAddCliked(false);
    setselectedVisit(null);
    seteditRowData(null);
  };
  useEffect(() => {
    if (loading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
  }, [loading]);

  return (
    <div>
      {loading ? (
        <ContentLoader />
      ) : (
        <>
          <PopupComponent fullScreen open={open} onClose={handleClose} style={{ margin: '15px' }}>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div" />
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
              sx={{ position: 'fixed', width: '32px', height: '32px', right: '24px', top: '24px', zIndex: 12 }}
            >
              <CloseIcon />
            </IconButton>

            <Grid container spacing={3} mt={0} sx={{ height: '100%' }}>
              <Grid item xs={2} sx={{ borderRight: '1px solid #ccc' }}>
                <Box display={'flex'} justifyContent={'space-between'} alignContent={'center'} pl={2} mb={2}>
                  <Typography variant="h6" sx={{ textOverflow: 'ellipsis', overflow: 'hidden' }}>
                    {selectedVisit?.visit_crf?.custom_name ?? selectedVisit?.visit_crf?.meta?.title}
                  </Typography>
                  <IconButton sx={{ mt: -0.5, alignSelf: 'start' }}>
                    <MoreVertIcon />
                  </IconButton>
                </Box>
                <CRFVisitEventsMenu
                  visitsData={visitsData}
                  bookMarkKey={bookMarkKey}
                  setselectedVisit={setselectedVisit}
                  selectedVisit={selectedVisit}
                  modifiedFormConfig={modifiedFormConfig}
                  setmodifiedFormConfig={didsetmodifiedFormConfig}
                  seteditRowData={seteditRowData}
                  editRowData={editRowData}
                  bookMarkField={bookMarkField}
                  exitValue={exitValue}
                  setExitValue={setExitValue}
                  exitPopup={exitPopup}
                  setExitPopup={setExitPopup}
                  currentAddedEvent={currentAddedEvent}
                  isUpdate={isUpdate}
                  currentEditEventData={currentEditEventData}
                  isAddCliked={isAddCliked}
                  isAddMode={isAddMode}
                  individualEventData={individualEventData}
                  setisUpdate={setisUpdate}
                  selectedAppointment={selectedAppointment}
                />
              </Grid>
              <Grid item xs={10} display={'flex'}>
                {modifiedFormConfig ? (
                  <CRFFormModal
                    handleCloseModel={handleClose}
                    formConfig={modifiedFormConfig}
                    selectedCRFFormCode={selectedCRFFormCode}
                    parent_id={parent_id}
                    isUpdate={isUpdate}
                    setisUpdate={setisUpdate}
                    selectedVisit={selectedVisit}
                    visitsData={visitsData}
                    editRowData={editRowData}
                    setselectedVisit={setselectedVisit}
                    seteditRowData={seteditRowData}
                    bookMarkKey={bookMarkKey}
                    bookMarkField={bookMarkField}
                    exitValue={exitValue}
                    setExitValue={setExitValue}
                    setcurrentAddedEvent={setcurrentAddedEvent}
                    setcurrentEditEventData={setcurrentEditEventData}
                    setisAddCliked={setisAddCliked}
                    individualEventData={individualEventData}
                  />
                ) : null}
              </Grid>
            </Grid>
          </PopupComponent>
          <PopupComponent
            open={exitPopup}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="confirm-modal"
            child
          >
            <DialogTitle id="alert-dialog-title">{'Confirm Exit'}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description" sx={{ marginBottom: '16px' }}>
                Changes you made will not be saved. Would you like to discard them?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleExitPopupSubmit} className="grey-btn">
                Yes
              </Button>
              <Button onClick={handleExitPopupClose} autoFocus>
                No
              </Button>
            </DialogActions>
          </PopupComponent>
        </>
      )}
    </div>
  );
};
export default CRFBasePopup;
